/**
*
* RedHero
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import formatDate from 'helpers/formatDate';

import Wrapper from 'components/Templates/dynamics/Wrapper';


class RedHero extends React.PureComponent {

  render() {


    const {
      commonData,
      openEditor,
      commonProps,
      defaultValues
    } = this.props;

    const {
      dateFrom,
      dateTo,
      timezone,
      city,
      isOnline,
      dateFromWithTime,
      dateToWithTime
    } = defaultValues;

    const dateToValue = formatDate(dateFromWithTime ? dateFromWithTime : dateFrom, dateToWithTime ? dateToWithTime : dateTo, timezone);

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'horizontalWrapper'}
          editorData={
                {
                  editorType: 'horizontalWrapper',
                  ...commonData
                }
              }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'heroImageWrapper'}
            editorData={
                {
                  editorType: 'heroImageWrapper',
                  ...commonData
                }
              }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'heroImage'}
              editorData={
                {
                  editorType: 'heroImage',
                  ...commonData
                }
              }
            >
            </Wrapper>
          </Wrapper>

          <Wrapper
            {...commonProps}
            
            typeOfStyle={'heroCenterWrapper'}
            editorData={
                {
                  editorType: 'heroCenterWrapper',
                  ...commonData
                }
              }
          >
            {
              dateToValue ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'eventDate'}
                  editorData={
                      {
                        editorType: 'eventDate',
                        ...commonData
                      }
                    }
                >
                  {dateToValue}
                </Wrapper>
              ) : ''
            }
            {
              city && !isOnline ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'eventCity'}
                  editorData={
                      {
                        editorType: 'eventCity',
                        ...commonData
                      }
                    }
                >
                  {city}
                </Wrapper>
              ) : ''
            }
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'title'}
              defaultValues={defaultValues}
              type={'text'}
              editorData={
                  {
                    editorType: 'title',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              editorData={
                  {
                    editorType: 'paragraph',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'headlineSponsorTitle'}
              defaultValues={
                {
                  headlineSponsorTitle: 'Sponsor'
                }
              }
              type={'text'}
              editorData={
                  {
                    editorType: 'headlineSponsorTitle',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'headlineSponsorLogo'}
              editorData={
                  {
                    editorType: 'headlineSponsorLogo',
                    ...commonData
                  }
                }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'buttonsCenterWrapper'}
              editorData={
                  {
                    editorType: 'buttonsCenterWrapper',
                    ...commonData
                  }
                }
            >
              <Wrapper
                {...commonProps}
                
                type={'text'}
                typeOfStyle={'buttonHeroPrimary'}
                editorData={
                    {
                      editorType: 'buttonHeroPrimary',
                      ...commonData
                    }
                  }
              />
              <Wrapper
                {...commonProps}
                
                type={'text'}
                typeOfStyle={'buttonHeroSecondary'}
                editorData={
                    {
                      editorType: 'buttonHeroSecondary',
                      ...commonData
                    }
                  }
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );
  }
}

RedHero.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  defaultValues: PropTypes.object,
};

export default RedHero;
